const CATEGORIAS_TRANSACCIONES = {
  TIEMPO_AIRE: "1",
  PAQUETES: "2",
  SERVICIOS: "3",
  GIFTCARDS: "4",
};

export default CATEGORIAS_TRANSACCIONES;
